import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from 'client/util/baseQueryWithReauth';

export const sessionApiSlice = createApi({
  reducerPath: 'sessionReducer',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Session'],
  endpoints: builder => ({
    // Get user's active sessions with security analysis
    getActiveSessions: builder.query({
      query: () => '/auth/sessions',
      providesTags: ['Session'],
    }),

    // Get all user sessions (including revoked)
    getAllSessions: builder.query({
      query: () => '/auth/sessions/all',
      providesTags: ['Session'],
    }),

    // Revoke specific session
    revokeSession: builder.mutation({
      query: sessionId => ({
        url: `/auth/sessions/${sessionId}/revoke`,
        method: 'POST',
      }),
      invalidatesTags: ['Session'],
    }),

    // Revoke all other sessions except current
    revokeAllOtherSessions: builder.mutation({
      query: refreshToken => ({
        url: '/auth/sessions/revoke-others',
        method: 'POST',
        body: { refreshToken },
      }),
      invalidatesTags: ['Session'],
    }),

    // Logout (revoke current session)
    logout: builder.mutation({
      query: refreshToken => ({
        url: '/auth/logout',
        method: 'POST',
        body: { refreshToken },
      }),
      invalidatesTags: ['Session'],
    }),

    // Admin: Get security summary for all users
    getSecuritySummary: builder.query({
      query: () => '/admin/sessions/security-summary',
      providesTags: ['Session'],
    }),

    // Admin: Revoke user's sessions
    adminRevokeUserSessions: builder.mutation({
      query: ({ userId, reason }) => ({
        url: `/admin/users/${userId}/sessions/revoke`,
        method: 'POST',
        body: { reason },
      }),
      invalidatesTags: ['Session'],
    }),

    // Admin: Get security analysis for specific user
    adminGetUserSecurityAnalysis: builder.query({
      query: userId => `/admin/users/${userId}/security-analysis`,
      providesTags: ['Session'],
    }),
  }),
});

export const {
  useGetActiveSessionsQuery,
  useGetAllSessionsQuery,
  useRevokeSessionMutation,
  useRevokeAllOtherSessionsMutation,
  useLogoutMutation,
  useGetSecuritySummaryQuery,
  useAdminRevokeUserSessionsMutation,
  useAdminGetUserSecurityAnalysisQuery,
  reducer: sessionReducer,
} = sessionApiSlice;
